import React from "react";
import { Typography, Row, Col, Card, Space } from "antd";
import { HomeFilled, EnvironmentFilled, ShoppingFilled } from "@ant-design/icons";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const { Title, Paragraph, Text } = Typography;

const InfoContent = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: <HomeFilled style={{ fontSize: "24px", color: "#1890ff" }} />,
      key: "beds"
    },
    {
      icon: <EnvironmentFilled style={{ fontSize: "24px", color: "#1890ff" }} />,
      key: "climate"
    },
    {
      icon: <ShoppingFilled style={{ fontSize: "24px", color: "#1890ff" }} />,
      key: "appliances"
    },
  ];

  return (
    <div
      style={{
        margin: "24px",
        marginTop: "64px",
        marginBottom: "64px",
      }}
    >
      <Row gutter={[32, 48]} justify="center">
        <Col xs={24} md={16}>
          <Paragraph
            style={{
              fontSize: "18px",
              textAlign: "center",
              marginTop: "40px",
              marginBottom: "40px",
              color: "#34495e",
              fontStyle: "italic",
              lineHeight: "1.8",
              letterSpacing: "0.3px",
            }}
          >
            {t('infoContent.apartmentDescription')}
          </Paragraph>
        </Col>
        <Col xs={24}>
          <Row gutter={[32, 32]} justify="center" style={{ height: "100%" }}>
            {features.map((feature, index) => (
              <Col xs={24} sm={8} key={index} style={{ display: "flex" }}>
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                  style={{ width: "100%" }}
                >
                  <Card
                    style={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      textAlign: "center",
                      borderRadius: "12px",
                      border: "1px solid #f0f0f0",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                      transition: "all 0.3s ease",
                    }}
                    bodyStyle={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                    hoverable
                  >
                    <Space
                      direction="vertical"
                      align="center"
                      style={{ width: "100%" }}
                    >
                      <motion.div
                        initial={{ scale: 1 }}
                        whileHover={{ scale: 1.2 }}
                        transition={{ duration: 0.2 }}
                      >
                        {React.cloneElement(feature.icon, {
                          style: {
                            fontSize: "36px",
                            color: "#1890ff",
                            marginBottom: "16px",
                          },
                        })}
                      </motion.div>
                      <Title
                        level={4}
                        style={{
                          margin: "0 0 16px",
                          color: "#2c3e50",
                          fontWeight: 600,
                        }}
                      >
                        {t(`infoContent.features.${feature.key}.title`)}
                      </Title>
                      <Text
                        style={{
                          color: "#5a6c7d",
                          fontSize: "15px",
                          lineHeight: "1.6",
                        }}
                      >
                        {t(`infoContent.features.${feature.key}.description`)}
                      </Text>
                    </Space>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default InfoContent;
